import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FetchAvaliableLanguagesRequest } from '@containers/i18n/store/i18n.actions';
import { LanguagesService } from '@containers/languages/languages.service';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ShowSnackbar } from '@shared/shared.actions';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Language } from '../../../i18n/store/i18n.interface'
import { COUNTRIES, Country } from './countries';

@Component({
  selector: 'app-languages-crud',
  templateUrl: './languages-crud.component.html',
  styleUrls: ['./languages-crud.component.scss']
})
export class LanguagesCrudComponent implements OnInit {

  private _subs: Array<Subscription> = [];
  key: string;
  isLoading;
  form: FormGroup
  currentLanguage: string;

  isUpdateMode: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<any>,
    private fb: FormBuilder,
    private router: Router,
    private languagesService: LanguagesService,
    private translateService: TranslateService,
    @Inject(COUNTRIES) public countries: Array<Country>

  ) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      available: [false],
      isDefault: [false],
      country: ['', Validators.required]
    })
    
    this.getParams();
    this.form.valueChanges.subscribe(console.log)
  }

  ngOnDestroy(): void {
    this._subs
      .filter(sub => Boolean(sub))
      .forEach(sub => sub.unsubscribe())
  }


  getParams() {
    const s = this.activatedRoute.queryParamMap
      .subscribe(queryParamMap => {
        if (queryParamMap.keys.length > 0) {
          this.isUpdateMode = true;
          this.countryControll.disable();
          this.countryControll.setValue({
            iso2code: queryParamMap.get('iso2code'),
            name: queryParamMap.get('name')
          })
          this.isDefaultControll.setValue(queryParamMap.get('isDefault') === 'true');
          this.availableControll.setValue(queryParamMap.get('available') === 'true');
          this.form.updateValueAndValidity();
        }
        else {
          this.isUpdateMode = false;
        }
      })


    this._subs.push(s);
  }

  onSubmit() {
    this.isLoading = true;
    const value = this.form.getRawValue();
    const language: Language = {
      available: value.available,
      isDefault: value.isDefault,
      iso2code: value.country.iso2code,
      name: value.country.name
    }
    if (this.isUpdateMode) {
      this.languagesService.updateLanguage(this.countryControll.value.iso2code, language)
        .pipe(
          finalize(() => this.isLoading = false)
        )
        .subscribe(res => {
          this.store.dispatch(new FetchAvaliableLanguagesRequest());
        })
    }
    else {
      this.languagesService.createLanguage(language)
        .pipe(
          finalize(() => this.isLoading = false)
        )
        .subscribe(res => {
          this.router.navigate(['/admin/languages', 'crud'], { queryParams: language });
          this.store.dispatch(new FetchAvaliableLanguagesRequest());
        })
    }
  }


  get availableControll(): AbstractControl {
    return this.form.get('available')
  }

  get isDefaultControll(): AbstractControl {
    return this.form.get('isDefault')
  }

  get countryControll(): AbstractControl {
    return this.form.get('country')
  }

  check(e: Event, control: AbstractControl) {
    control.setValue((<HTMLInputElement>e.target).checked);
    this.form.markAsDirty();
    this.form.markAsTouched();
  }

}
